import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EqualToDirective } from './equal-to.directive';
import { GreaterThanOrEqualToDirective } from './greater-than-or-equal-to.directive';
import { GreaterThanDirective } from './greater-than.directive';
import { LowerThanOrEqualDirective } from './lower-than-or-equal.directive';
import { LowerThanDirective } from './lower-than.directive';
import { NotEqualToDirective } from './not-equal-to.directive';
export class AngularComparisonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    EqualToDirective,
    GreaterThanDirective,
    GreaterThanOrEqualToDirective,
    LowerThanOrEqualDirective,
    LowerThanDirective,
    NotEqualToDirective
  ],
  exports: [
    EqualToDirective,
    GreaterThanOrEqualToDirective,
    GreaterThanDirective,
    LowerThanOrEqualDirective,
    LowerThanDirective,
    NotEqualToDirective
  ] 
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AngularComparisonModule_tsickle_Closure_declarations() {
/** @type {?} */
AngularComparisonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AngularComparisonModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
